import { useDispatch } from 'react-redux';
import { Modal } from 'react-bootstrap';
import './CreateAndVerifyModal.css';
import React, { useEffect, useRef, useState } from 'react';
import Button from '@components/common/Button';
import endpoints from '@config/endpoints';
import { getDataWithCache, postDataJSON } from '../../../../../services/CommonApiService';
import { Spinner } from 'react-bootstrap';
import { updateChild } from '@store/actions/beneficiaryAction';
import CheckboxComponent from '@components/common/CheckBox';
import CommonFormFields from '@pages/Forms/CommonFormFields';
import { childModalDetails, CONSENT_DETAILS } from '@constants/index';
import profilePic from '../../../../../assets/png/default_profile.png';
import CustomTooltip from '@components/common/CustomTooltip';
import InfoBar from '@components/common/InfoBars';
import dayjs from 'dayjs';
import abhaImg from '../../../../../assets/png/ABHA.png';
import ChildOtpModal from '../../CreateNewChild/ChildOtpModal';
import ChildDetailsSelectionTable from '../../CreateNewChild/ChildDetailsSelectionTable';
import { useSelector } from 'react-redux';
import { RootState } from '@store/reducers';
import EditIcon from '../../../../../assets/svg_main/pencil-01.svg';
import { errorLogger } from '@utils/applicationLogUtils';
import { useNavigate } from 'react-router-dom';
import { getUserConsentLanguage } from '@services/childApiServices';
import { decodeWithKeyAndShift, encodeWithKeyAndShift } from '@utils/base64Utils';
import { handleChildABDMError, handleError, parseConsentTemplate } from '@utils/childUtils';
import { CHILD_SUCCESS_MESSAGES } from '../childConstants';
import { toast } from 'react-toastify';
import { isValidUuid } from '@utils/apiInputValidation';

interface objectType {
  isError: boolean;
  message: string;
  isDisable: boolean;
  value: any;
  id?: any;
  code?: any;
}

export interface formStateType {
  [key: string]: objectType;
}

interface showModalProps {
  showModal: boolean;
  handleClose: (option?:string) => void;
}

const CreateAndVerifyModal = ({
  showModal,
  handleClose,
}: showModalProps) => {

  const [showSpinner, setSHowSpinner] = useState<boolean>(false);
  const [consentShow, setConsentShow] = useState<boolean>(false);
  const [consentCheckbox, setConsentCheckbox] = useState<boolean>(false);
  const [childModalFormState, setChildModalFormState] = useState<formStateType>(
    {
      name: {
        isError: false,
        message: '',
        isDisable: false,
        value: '',
      },
      dob: {
        isError: false,
        message: '',
        isDisable: false,
        value: '',
      },
      gender: {
        isError: false,
        message: '',
        isDisable: false,
        value: '',
      },
    },
  );

  const [showParentModal, setShowParentModal] = useState<boolean>(showModal);
  const childImageData = useSelector((state: RootState) => state.beneficiary?.childImageData);
  const verifyChildFromGridData=  useSelector((state: RootState) => state.beneficiary?.verifyChildFromGridData);
  const childBenfId = useSelector((state: RootState) => state.beneficiary?.childBenfId);
  const updateChildVerifyFromView= useSelector((state: RootState) => state.beneficiary?.updateChildVerifyFromView);
  const childVerifyFromGrid=useSelector((state: RootState) => state.beneficiary?.childVerifyFromGrid);
  const beneficiaryDetails=useSelector((state: RootState) => state.beneficiary?.beneficiaryDetails);
  const [showVerifyAbhaCard,setShowVerifyAbhaCard] = useState<boolean>(true);
  const [childFlow,setChildFlow] =useState<string>('');
  const deliveryDate = useSelector((state: RootState) => state.beneficiary?.deliveryDate);
  const [childData, setChildData] = useState<any>(childModalDetails);
  const navigate=useNavigate()
  const dispatch = useDispatch();
  const [uploadMethod, setUploadMethod] = useState<'local' | 'url' | null>(
    null,
  );
  const [imageError, setImageError] = useState('');
  const [newImageUrl, setNewImageUrl] = useState<string>('');
  const inputRef = useRef<any>(null);
  const [showOtp, setShowOtp] = useState(false);
  const [showchildTable, setShowChildTable] = useState<boolean>(false);
  const [showChildForm, setShowChildForm] = useState<boolean>(false);
  const [parentDetailsFromAbdm, setParentDetailsFromAbdm] = useState<any>();
  const [imageBase64,setImageBase64] = useState<string>('');
  const [childDetailsFromParent, setChildDetailsFromParent] = useState<any>();
  const buttonName = newImageUrl ? 'Edit Profile Picture' : '+ Add Profile Picture';
  const icon = newImageUrl ? <EditIcon /> : '';
  const [consentLanguageData, setConsentLanguageData] = useState<any>([]);
  const [consentData, setConsentData] = useState<any>([]);
  const [checkedState, setCheckedState] = useState<boolean[]>([]);
  const isAllChecked = checkedState?.every((checked) => checked);
  const checkConsentIsPresent = () => {
    if(consentLanguageData?.length === 0){
      toast.error("Unable to fetch consent details. Please try again later.", {
        position: "top-center",
      });
      getConsentLanguage();
      return;
    }
    setConsentShow(true);
    setShowChildForm(false);
  }
  const handleShowConsentForm = () => {
    checkConsentIsPresent();
  };

  const handleConsenttoChildForm = () => {
    setConsentCheckbox(true);
    setConsentShow(false);
    setShowChildForm(true);
  };

  const getConsentLanguage = async () => {
    try {
      const response = await getUserConsentLanguage(CONSENT_DETAILS.CHILD_CONSENT_TYPE, CONSENT_DETAILS.CONSENT_NAME);
      setConsentData(response?.data?.[0]);
      const formatedConsentTemplate = parseConsentTemplate(response?.data?.[0], beneficiaryDetails?.[0]?.benf_name, verifyChildFromGridData);
      setConsentLanguageData(formatedConsentTemplate);
      const res: any = response?.data[0]?.length
      setCheckedState(new Array(res).fill(false));
    } catch (error: any) {
      errorLogger(error?.response?.data || error?.response || error)
    }
  };

  const handleCheckboxChange = (index: number, checked: boolean) => {
    const updatedCheckedState = [...checkedState];
    updatedCheckedState[index] = checked;
    setCheckedState(updatedCheckedState);
  };

  const handleSelectAll = (checked: boolean) => {
    setCheckedState(new Array(checkedState?.length).fill(checked));
  };

  useEffect(() => {
    setShowParentModal(showModal);
  },[showModal]);

  useEffect(() => {
    fetchGender();
    return () => {
      setChildModalFormState((prevState: any) => ({
        ...prevState,
        name: {
          ...prevState.name,
          value: '',
          isError: false,
          message: '',
        },
        dob: {
          ...prevState.dob,
          value: '',
          isError: false,
          message: '',
        },
        gender: {
          ...prevState.gender,
          value: '',
          isError: false,
          message: '',
        },
      }));
    };
  }, []);

  useEffect(() => {
    if((updateChildVerifyFromView || childVerifyFromGrid || verifyChildFromGridData)){
      fetchDeliveryInsideRch();
    }
  }, [verifyChildFromGridData]);

  const fetchDeliveryInsideRch = async () => {
    try {
      const benefId = childBenfId || beneficiaryDetails?.[0]?.benef_id;

      if (!isValidUuid(benefId)) {
        return;
      }

      const payload = {
        benefId,
      };
      
      const decodedResponse = verifyChildFromGridData
        ? JSON.parse(decodeWithKeyAndShift(verifyChildFromGridData)) : {};
      const response:any = await postDataJSON(endpoints.checkChildRegInsideRch, {
        data: encodeWithKeyAndShift(JSON.stringify(payload)),
      });
      if(response?.data[0]?.check_child_reg_inside_rch){
        setChildData((prevState: any) => ({
        ...prevState,
        dob: {
          ...prevState.dob,
          '#maxDate': dayjs(beneficiaryDetails?.dob || decodedResponse.childData?.dob).format('YYYY-MM-DD'),
          '#minDate': dayjs(beneficiaryDetails?.dob || decodedResponse.childData?.dob).format('YYYY-MM-DD'),
        }
      }))
      }
      else{
        setChildData((prevState: any) => ({
        ...prevState,
        dob: {
          ...prevState.dob,
            '#maxDate': dayjs(new Date()).format('YYYY-MM-DD'),
            '#minDate': dayjs().subtract(5, 'year').format('YYYY-MM-DD'),
        }
      }))
      }
    }
  catch(error:any){
      errorLogger(error?.response?.data||error?.response||error)
  }
}
const storeUserId = localStorage.getItem('userId');
const childGenderOptions = localStorage.getItem('childGenderOptions');

  const fetchGender = async () => {
    let genderData : any= [];
    try {
      if (storeUserId && childGenderOptions) {
        genderData = JSON.parse(decodeWithKeyAndShift(childGenderOptions));
      }
      else {
        genderData = await getDataWithCache<any[]>(endpoints.getChildGender);
        localStorage.setItem('childGenderOptions', encodeWithKeyAndShift(JSON.stringify(genderData)));
      }
        const genderOptions = genderData?.data?.[0]?.map((key: any) => ({
          value: key.gender_name,
          label: key.gender_name,
          id: key.gender_id,
          code: key.gender_code,
        }));
         
      setChildData((prevState: any) => ({
        ...prevState,
        gender: {
          ...prevState.gender,
          '#options': genderOptions,
        },
      }));
      {deliveryDate && setChildData((prevState: any) => ({
        ...prevState,
        dob: {
          ...prevState.dob,
          '#maxDate': dayjs(deliveryDate).format('YYYY-MM-DD'),
          '#minDate': dayjs(deliveryDate).format('YYYY-MM-DD'),
        }
      }));}
    } catch(error:any){
      errorLogger(error?.response?.data||error?.response||error)
    }
  };

  const validateField = (value:any) => {
    return !/^[A-Za-z\s]+$/.test(value);
  }

  const handleModalDataChange = (
    value: any,
    key: string,
    id: any,
    option: any,
    code: any,
  ) => {
    if(key === 'name' && validateField(value) && value) {
      return;
    }
    setChildModalFormState((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        id: id,
        code: code,
        isError: false,
        message: '',
      },
    }));
  };

  const handleUploadClick = (method: 'local' | 'url') => {
    inputRef.current?.click();
    setUploadMethod(method);
  };

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const selectedFile = event.target.files && event.target.files[0];
    setImageError('');
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      
      if (fileSize > 102400) {
        setImageError('File size must be less than or equal to 100KB');
        return;
      }
      if (!['image/jpeg', 'image/png', 'image/jpg'].includes(fileType)) {
        setImageError('Only JPG, JPEG and PNG images are allowed');
        return;
      }
      setNewImageUrl(URL.createObjectURL(selectedFile));
      setUploadMethod(null);
      const file = selectedFile;
      convertImgToBase64(file);
      const formData = new FormData();
      formData.append('file', file);
      dispatch(updateChild('childImageData', formData));
      dispatch(updateChild('childModalImageFile', file));
    }
  };

  const convertImgToBase64 = (file: any) => {
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        if (reader.result) {
          const base64String = reader.result as string;
          setImageBase64(base64String.split(',')[1]);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const onClose = () => {
    handleClose();
  };

  const handleChildSubmit = async () => {
    let checkError = false;
    if (!childModalFormState.name.value) {
      setChildModalFormState((prevState: any) => ({
        ...prevState,
        name: {
          ...prevState.name,
          isError: true,
          message: 'Child name cannot be blank.',
        },
      }));
      checkError = true;
    }
    if (!childModalFormState.dob.value) {
      setChildModalFormState((prevState: any) => ({
        ...prevState,
        dob: {
          ...prevState.dob,
          isError: true,
          message: 'DOB cannot be blank. Select valid DOB.',
        },
      }));
      checkError = true;
    }
    if (!childModalFormState.gender.value) {
      setChildModalFormState((prevState: any) => ({
        ...prevState,
        gender: {
          ...prevState.gender,
          isError: true,
          message: 'Gender cannot be blank. Select valid gender.',
        },
      }));
      checkError = true;
    }
    if (!checkError) {
      try {
        const createChildPayload: any = {
          token: parentDetailsFromAbdm?.token,
          name: childModalFormState.name.value,
          date: dayjs(childModalFormState.dob.value).format('DD'),
          month: dayjs(childModalFormState.dob.value).format('MM'),
          year: dayjs(childModalFormState.dob.value).format('YYYY'),
          gender: childModalFormState.gender.value === 'Male' ? 'M' : 'F',
          filePath:null,
          url:null,
          description:''
        };
        //Need this for Future reference
        // if (childImageData instanceof FormData) {
        //   const responses = await axios.post(`${endpoints.upload}`, childImageData, Auth.loggedInWithMultipart())
        //   createChildPayload = {
        //     ...createChildPayload,
        //     filePath: responses.data.data.filePath || null,
        //     url: responses.data.data.fileUrl || null,
        //     description: 'Image for child',
        //   };
        // }
        setSHowSpinner(true);
        const responses:any = await postDataJSON(endpoints.createChild, createChildPayload);
        const decodedResponse= JSON.parse(decodeWithKeyAndShift(responses.data));
        if(childVerifyFromGrid){
          navigate(`/beneficiaries/create-new-child`, { state: verifyChildFromGridData });
        }
        if (decodedResponse?.message === CHILD_SUCCESS_MESSAGES.ACCOUNT_CREATED_SUCCESS) {
          setSHowSpinner(false);
          dispatch(updateChild('createSubmitClicked', true));
          dispatch(updateChild('verifySubmitClicked', false));
          const selectedConsentIds = consentData
          .map((item: any, idx: number) => checkedState[idx] ? item?.consent_template_id : null)
          .filter((id: any) => id !== null);
          dispatch(updateChild('childConsentIds', selectedConsentIds));
          dispatch(updateChild('regChildDetails', decodedResponse?.ABHAProfile));
          handleClose();
        } else {
          handleChildABDMError(decodedResponse);
          setSHowSpinner(false);
        }
        
      } catch (error: any) {
        const decodedResponse= JSON.parse(decodeWithKeyAndShift(error?.response?.data||error?.response||error));
        handleChildABDMError(decodedResponse);
        setSHowSpinner(false);
        errorLogger(decodedResponse);
      }
    }
  };

  const handleChildTableSubmit = (childData: any) => {
    dispatch(updateChild('verifySubmitClicked', true));
    dispatch(updateChild('createSubmitClicked', false));
    dispatch(updateChild('verifiedChildDetails', childData));
    if(childVerifyFromGrid){
      navigate(`/beneficiaries/create-new-child`, { state: verifyChildFromGridData });
    }
    handleClose();
  };

  const handleOtpSubmit = async (value: any, res: any) => {
    if (childFlow === 'create') {
      setShowChildForm(true);
      setParentDetailsFromAbdm(res);
      getConsentLanguage();
    } else if (childFlow === 'verify') {
      const data = {
        token: res?.token,
      };
      try {
        setSHowSpinner(true);
        const childDetailsRes:any = await postDataJSON(endpoints.getChildDetailsFromParent, data);
        setSHowSpinner(false);
        setChildDetailsFromParent(childDetailsRes?.data?.children);
        setShowParentModal(false);
        setShowChildTable(true);
      } catch(error:any) {
        setSHowSpinner(false);
        errorLogger(error?.response?.data||error?.response||error);
      }
    }
    setShowOtp(false);
  };

  const handleBack = () => {
    if (showChildForm) {
      setShowChildForm(false);
      setShowOtp(true);
    } else if (showchildTable) {
      setShowChildTable(false);
      setShowOtp(true);
    } else if (consentShow) {
      setConsentShow(false);
      setShowOtp(false);
      setShowChildForm(true);
    } 
    else if(showOtp){
      setShowVerifyAbhaCard(true);
      setShowOtp(false)
    } 
    else {
      handleClose('back');
    }
  };

  const handleDiscard = () => {
    setShowChildForm(false);
    setShowChildTable(false);
    setConsentShow(false);
    setShowOtp(false);
    setShowVerifyAbhaCard(true);
    onClose();
  };
  const handleChildDiscard = () => {
    setShowChildTable(false);
    setShowVerifyAbhaCard(true);
    handleClose();

  };
  const onChildClose = () => {
    setShowChildTable(false);
    handleClose();

  };
  const handleChildBack = () => {
    setShowChildTable(false);
    handleClose();

  };

  return (
    <>
      <div className="modal_verification_beneficiaries">
        <Modal
          show={showParentModal}
          onHide={() => {
            setShowChildForm(false);
            setShowChildTable(false);
            setConsentShow(false);
            setShowOtp(false);
            setShowVerifyAbhaCard(true);
            onClose();
          }}
          dialogClassName={'child-verification-card-modal'}
          centered={true}
          backdrop = "static"
        >
          <Modal.Body>
            <div className="modal-body-header">
              <div className="modal-body-back" onClick={handleBack}>
                <i className="bi bi-arrow-left"></i>
                <span className="ms-1">Back</span>
              </div>
              <div className="modal-body-discard" onClick={handleDiscard}>
                <span className="me-0">Discard</span>
                <i className="bi bi-x"></i>
              </div>
            </div>
            <div className="child-modals">
              {showChildForm && !consentShow && (
                <div className="modal-profile-picture">
                  <h1>Create Bal ABHA Number</h1>
                  <div className="profile-picture-container">
                    <div className="modal-image">
                      {newImageUrl !== '' ? (
                        <img
                          className="profile-picture"
                          src={newImageUrl}
                          alt="Profile Image"
                        />
                      ) : (
                        <img
                          className="profile-picture"
                          src={profilePic}
                          alt="Profile Image"
                        />
                      )}
                    </div>
                    <div>
                      <div className="add-profile-container">
                        <div>
                          <div>
                            <div className="profile-buttons">
                              <Button
                                onClick={() => {
                                  handleUploadClick('local')
                                }}
                                disabled={false}
                                id="add-profile-picture"
                                buttonName={buttonName}
                                colorType={'primary'}
                                iconPosition={'left'}
                                icon={icon}
                              />
                              <span className="tooltip-profile-pic">
                                <CustomTooltip
                                  text={
                                    'File size must be less than or equal to 100KB and Only JPG, JPEG and PNG images are allowed'
                                  }
                                />
                              </span>
                            </div>

                            {imageError.length > 0 && (
                              <InfoBar
                                variant="danger"
                                message={imageError}
                                className="input_field_class profile-pic-error"
                              />
                            )}
                          </div>
                          <input
                            type="file"
                            accept=".jpg,.jpeg,.png"
                            onChange={handleFileChange}
                            className="profile-picture-hidden-input"
                            ref={inputRef}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <CommonFormFields
                    formData={childData}
                    formState={childModalFormState}
                    handleFormChange={handleModalDataChange}
                  />
                  <div className="modal-checkboxes">
                    <CheckboxComponent
                      className=""
                      checkBoxName=""
                      disabled={false}
                      onCheckboxChange={() => {}}
                      placeCheckboxBefore={false}
                      isChecked={consentCheckbox}
                    />
                    <p>
                      I hearby confirm that I have explained below mentioned
                      <button onClick={handleShowConsentForm}
                        disabled={!childModalFormState?.name.value || !childModalFormState?.dob.value  ||!childModalFormState?.gender.value}
                        className="child_consent_form">
                        Consent Process
                      </button>{' '}
                      to the individual for the creation of ABHA and linking
                      with JANANI programme/application
                    </p>
                  </div>
                  <span>
                    {showSpinner && (
                      <>
                        <span>Loading...</span>
                        <Spinner />
                      </>
                    )}{' '}
                  </span>
                  <div className="child-modal-button">
                    <Button
                      onClick={handleChildSubmit}
                      disabled={!consentCheckbox}
                      id=""
                      buttonName={'Submit'}
                      colorType={'primary'}
                      icon={''}
                      iconPosition={''}
                    />
                  </div>
                </div>
              )}
              {consentShow && (
                <div className="aadhar_consent_form_enlarge">
                  <h1 className="aadhar_headings">Consent Process</h1>
                  <div className="consent_form_for_aadhar">
                    I hereby declare that:
                    <CheckboxComponent
                      isChecked={isAllChecked}
                      onCheckboxChange={handleSelectAll}
                      disabled={false}
                      className="consent-select-all"
                      checkBoxName="Select All"
                    />
                    <ol className="aadhaar-consent-ol">
                      {consentLanguageData?.map((item: any, index: number) => (
                        <li key={index} className="aadhaar-consent-list">
                          <div className="aadhaar-consent-list-container">
                            <CheckboxComponent
                              isChecked={checkedState?.[index]}
                              onCheckboxChange={(checked) =>
                                handleCheckboxChange(index, checked)
                              }
                              disabled={false}
                              className={`consent-checkbox-item-${index}`}
                              checkBoxName={''}
                            />
                            <div className="aadhaar-consent-list-content-container">
                              <div
                                className="heading-container"
                                style={{ display: 'flex' }}
                              >
                                <span style={{ marginRight: '2px' }}>
                                  {item.consentNumber}.
                                </span>
                                <span>{item.mainHeading}</span>
                              </div>
                              <div style={{ paddingLeft: '5px' }}>
                                <ol
                                  style={{
                                    listStyleType: 'decimal',
                                    paddingLeft: '20px',
                                  }}
                                >
                                  {item.content.map(
                                    (consent: any, i: number) => (
                                      <li key={i}>
                                        <span>{consent.value}</span>
                                        {consent.subpoints.length > 0 && (
                                          <ul className="consent-subpoint-container">
                                            {consent.subpoints.map(
                                              (subpoint: any, j: number) => (
                                                <li
                                                  key={j}
                                                  style={{ display: 'flex' }}
                                                >
                                                  <div
                                                    style={{
                                                      marginRight: '10px',
                                                    }}
                                                  >
                                                    ({subpoint.key})
                                                  </div>
                                                  <div>{subpoint.value}</div>
                                                </li>
                                              ),
                                            )}
                                          </ul>
                                        )}
                                        {consent.continuation.length > 0 && (
                                          <span>{consent.continuation[0]}</span>
                                        )}
                                      </li>
                                    ),
                                  )}
                                </ol>
                              </div>
                            </div>
                          </div>
                        </li>
                      ))}
                    </ol>
                  </div>
                  <div className="child-content-button">
                    <Button
                      onClick={handleConsenttoChildForm}
                      disabled={isAllChecked ? false : true}
                      id="aadhar-beneficiary-submit"
                      buttonName={'Continue'}
                      colorType={'primary'}
                      icon={''}
                      iconPosition={''}
                    />
                  </div>
                </div>
              )}
              {showOtp && (
                <ChildOtpModal
                  otpLabel={' Enter OTP sent to your registered mobile number'}
                  onClickSubmit={handleOtpSubmit}
                  header={'Enter OTP'}
                  flow={childFlow}
                  showOtpSpinner={showSpinner}
                  isChildKYC={false}
                  isChildLogin={false}
                />
              )}
              { showVerifyAbhaCard &&
                (<div className='gender-container'>
                <div className='gender-box' onClick={() =>{
                  setShowVerifyAbhaCard(false)
                  setShowOtp(true)
                  setChildFlow('create')
                  if(updateChildVerifyFromView){
                    dispatch(updateChild("childFlow", 'view create'));
                  }
                  else{
                    dispatch(updateChild("childFlow", 'create'));
                  }
                } }>
                  <img id='img' src={abhaImg} alt="Create Button" />
                    Create
                </div>
                <div className='gender-box' onClick={() => {
                  setShowVerifyAbhaCard(false)
                  setShowOtp(true)
                  setChildFlow('verify')
                  if(updateChildVerifyFromView){
                    dispatch(updateChild("childFlow", 'view verify'));
                  }
                  else{
                    dispatch(updateChild("childFlow", 'verify'));
                  }
                }}>
                    <img id='img' src={abhaImg} alt="Verify Button" />Verify</div>
            </div>)
              }
            </div>
          </Modal.Body>
        </Modal>
      </div>
      {childFlow === 'verify' && showchildTable && (
        <ChildDetailsSelectionTable
          childData={childDetailsFromParent}
          handleChildTableSubmit={handleChildTableSubmit}
          handleBack={handleChildBack}
          handleDiscard={handleChildDiscard}
          onClose={onChildClose}
          showModal={showchildTable}
        />
      )}
    </>
  );
};
export default CreateAndVerifyModal;
